import { render, staticRenderFns } from "./zbOldItemReturnDialog.vue?vue&type=template&id=4db10f84&scoped=true"
import script from "./zbOldItemReturnDialog.vue?vue&type=script&lang=js"
export * from "./zbOldItemReturnDialog.vue?vue&type=script&lang=js"
import style0 from "./zbOldItemReturnDialog.vue?vue&type=style&index=0&id=4db10f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db10f84",
  null
  
)

export default component.exports